"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopToJSON = exports.ShopFromJSONTyped = exports.ShopFromJSON = exports.instanceOfShop = void 0;
var runtime_1 = require("../runtime");
var FAQInfo_1 = require("./FAQInfo");
var FeaturedCategorySettings_1 = require("./FeaturedCategorySettings");
var FeaturedProductSettings_1 = require("./FeaturedProductSettings");
var FilterInputItem_1 = require("./FilterInputItem");
var FooterInfo_1 = require("./FooterInfo");
var Hero_1 = require("./Hero");
var ProductImageSettings_1 = require("./ProductImageSettings");
var ShopAssortmentType_1 = require("./ShopAssortmentType");
var ShopProductSizeDisplayType_1 = require("./ShopProductSizeDisplayType");
var ShopVatMode_1 = require("./ShopVatMode");
var Teaser_1 = require("./Teaser");
var UPSInfo_1 = require("./UPSInfo");
var Unit_1 = require("./Unit");
/**
 * Check if a given object implements the Shop interface.
 */
function instanceOfShop(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfShop = instanceOfShop;
function ShopFromJSON(json) {
    return ShopFromJSONTyped(json, false);
}
exports.ShopFromJSON = ShopFromJSON;
function ShopFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'vatMode': !(0, runtime_1.exists)(json, 'vatMode') ? undefined : (0, ShopVatMode_1.ShopVatModeFromJSON)(json['vatMode']),
        'assortmentType': !(0, runtime_1.exists)(json, 'assortmentType') ? undefined : (0, ShopAssortmentType_1.ShopAssortmentTypeFromJSON)(json['assortmentType']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'uri': !(0, runtime_1.exists)(json, 'uri') ? undefined : json['uri'],
        'bodyText': !(0, runtime_1.exists)(json, 'bodyText') ? undefined : json['bodyText'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'agreement': !(0, runtime_1.exists)(json, 'agreement') ? undefined : json['agreement'],
        'contactEmail': !(0, runtime_1.exists)(json, 'contactEmail') ? undefined : json['contactEmail'],
        'contactPhone': !(0, runtime_1.exists)(json, 'contactPhone') ? undefined : json['contactPhone'],
        'contactName': !(0, runtime_1.exists)(json, 'contactName') ? undefined : json['contactName'],
        'company': !(0, runtime_1.exists)(json, 'company') ? undefined : json['company'],
        'companyText': !(0, runtime_1.exists)(json, 'companyText') ? undefined : json['companyText'],
        'vatExcluded': !(0, runtime_1.exists)(json, 'vatExcluded') ? undefined : json['vatExcluded'],
        'displayMarketingAgreement': !(0, runtime_1.exists)(json, 'displayMarketingAgreement') ? undefined : json['displayMarketingAgreement'],
        'marketingAgreement': !(0, runtime_1.exists)(json, 'marketingAgreement') ? undefined : json['marketingAgreement'],
        'privacyPolicyUrl': !(0, runtime_1.exists)(json, 'privacyPolicyUrl') ? undefined : json['privacyPolicyUrl'],
        'legalNoticeUrl': !(0, runtime_1.exists)(json, 'legalNoticeUrl') ? undefined : json['legalNoticeUrl'],
        'isB2BShop': !(0, runtime_1.exists)(json, 'isB2BShop') ? undefined : json['isB2BShop'],
        'assortmentFilters': !(0, runtime_1.exists)(json, 'assortmentFilters') ? undefined : (json['assortmentFilters'] === null ? null : json['assortmentFilters'].map(FilterInputItem_1.FilterInputItemFromJSON)),
        'files': !(0, runtime_1.exists)(json, 'files') ? undefined : json['files'],
        'selectedUnit': !(0, runtime_1.exists)(json, 'selectedUnit') ? undefined : (0, Unit_1.UnitFromJSON)(json['selectedUnit']),
        'useProductStock': !(0, runtime_1.exists)(json, 'useProductStock') ? undefined : json['useProductStock'],
        'productSizeDisplay': !(0, runtime_1.exists)(json, 'productSizeDisplay') ? undefined : (0, ShopProductSizeDisplayType_1.ShopProductSizeDisplayTypeFromJSON)(json['productSizeDisplay']),
        'productImageSettings': !(0, runtime_1.exists)(json, 'productImageSettings') ? undefined : (0, ProductImageSettings_1.ProductImageSettingsFromJSON)(json['productImageSettings']),
        'useAttestation': !(0, runtime_1.exists)(json, 'useAttestation') ? undefined : json['useAttestation'],
        'useAgreementFile': !(0, runtime_1.exists)(json, 'useAgreementFile') ? undefined : json['useAgreementFile'],
        'agreementFile': !(0, runtime_1.exists)(json, 'agreementFile') ? undefined : json['agreementFile'],
        'hero': !(0, runtime_1.exists)(json, 'hero') ? undefined : (0, Hero_1.HeroFromJSON)(json['hero']),
        'showUSPText': !(0, runtime_1.exists)(json, 'showUSPText') ? undefined : json['showUSPText'],
        'featuredCategories': !(0, runtime_1.exists)(json, 'featuredCategories') ? undefined : (0, FeaturedCategorySettings_1.FeaturedCategorySettingsFromJSON)(json['featuredCategories']),
        'featuredProducts': !(0, runtime_1.exists)(json, 'featuredProducts') ? undefined : (0, FeaturedProductSettings_1.FeaturedProductSettingsFromJSON)(json['featuredProducts']),
        'upsInfo': !(0, runtime_1.exists)(json, 'upsInfo') ? undefined : (0, UPSInfo_1.UPSInfoFromJSON)(json['upsInfo']),
        'teaser': !(0, runtime_1.exists)(json, 'teaser') ? undefined : (0, Teaser_1.TeaserFromJSON)(json['teaser']),
        'checkoutRequirePhoneNumber': !(0, runtime_1.exists)(json, 'checkoutRequirePhoneNumber') ? undefined : json['checkoutRequirePhoneNumber'],
        'faqInfo': !(0, runtime_1.exists)(json, 'faqInfo') ? undefined : (0, FAQInfo_1.FAQInfoFromJSON)(json['faqInfo']),
        'footerInfo': !(0, runtime_1.exists)(json, 'footerInfo') ? undefined : (0, FooterInfo_1.FooterInfoFromJSON)(json['footerInfo']),
    };
}
exports.ShopFromJSONTyped = ShopFromJSONTyped;
function ShopToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'vatMode': (0, ShopVatMode_1.ShopVatModeToJSON)(value.vatMode),
        'assortmentType': (0, ShopAssortmentType_1.ShopAssortmentTypeToJSON)(value.assortmentType),
        'name': value.name,
        'uri': value.uri,
        'bodyText': value.bodyText,
        'description': value.description,
        'agreement': value.agreement,
        'contactEmail': value.contactEmail,
        'contactPhone': value.contactPhone,
        'contactName': value.contactName,
        'company': value.company,
        'companyText': value.companyText,
        'vatExcluded': value.vatExcluded,
        'displayMarketingAgreement': value.displayMarketingAgreement,
        'marketingAgreement': value.marketingAgreement,
        'isB2BShop': value.isB2BShop,
        'assortmentFilters': value.assortmentFilters === undefined ? undefined : (value.assortmentFilters === null ? null : value.assortmentFilters.map(FilterInputItem_1.FilterInputItemToJSON)),
        'files': value.files,
        'selectedUnit': (0, Unit_1.UnitToJSON)(value.selectedUnit),
        'useProductStock': value.useProductStock,
        'productSizeDisplay': (0, ShopProductSizeDisplayType_1.ShopProductSizeDisplayTypeToJSON)(value.productSizeDisplay),
        'productImageSettings': (0, ProductImageSettings_1.ProductImageSettingsToJSON)(value.productImageSettings),
        'useAttestation': value.useAttestation,
        'useAgreementFile': value.useAgreementFile,
        'agreementFile': value.agreementFile,
        'hero': (0, Hero_1.HeroToJSON)(value.hero),
        'showUSPText': value.showUSPText,
        'featuredCategories': (0, FeaturedCategorySettings_1.FeaturedCategorySettingsToJSON)(value.featuredCategories),
        'featuredProducts': (0, FeaturedProductSettings_1.FeaturedProductSettingsToJSON)(value.featuredProducts),
        'upsInfo': (0, UPSInfo_1.UPSInfoToJSON)(value.upsInfo),
        'teaser': (0, Teaser_1.TeaserToJSON)(value.teaser),
        'checkoutRequirePhoneNumber': value.checkoutRequirePhoneNumber,
        'faqInfo': (0, FAQInfo_1.FAQInfoToJSON)(value.faqInfo),
        'footerInfo': (0, FooterInfo_1.FooterInfoToJSON)(value.footerInfo),
    };
}
exports.ShopToJSON = ShopToJSON;
